import React, { Component, Fragment } from "react";
import { injectIntl } from 'react-intl';
import { DatePicker, RangeDatePicker } from "jalali-react-datepicker";
import API from '../../api/index'
var classNames = require('classnames');
import ReactTimeAgo from 'react-time-ago'
import { NotificationManager } from "Components/ReactNotifications";
import moment from 'jalali-moment'

import {
    logoutUser
} from "Redux/actions";
import { connect } from "react-redux";
import CustomSelectInput from "Components/CustomSelectInput";
import Select from "react-select";
import {
    Row,
    Card,
    CardBody,
    CardTitle,
    Button,
    Modal,
    ModalBody,
    ModalHeader,
    Collapse,
    FormGroup,
    Label,
    Input,
    Form,
    timeoutsShape
} from "reactstrap";


import NumberFormat from 'react-number-format';
import { Colxx, Separator } from "Components/CustomBootstrap";


class archive extends Component {
    constructor(props) {
        super(props);

        this.state = {
            Operators: [],
            SystemLogs: [],
            paging: [],
            isRefreshing: false,
            isLoading: true,
            toggleSearchForm: false,
            APIResetData: {},
            APISearchData: {},
            search: {
                logTitle: "",
                logType: "",
                logTag: "",
                logAction: "",
                operatorID: "ALL",
                currentPage: 1,
                createdFrom: "",
                createdTo: ""
            }
        };



        this.setCreatedDateRange = this.setCreatedDateRange.bind(this);
        this.setClosedDateRange = this.setClosedDateRange.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.toggleSearchForm = this.toggleSearchForm.bind(this);
        this.doSearch = this.doSearch.bind(this);
        this.doReset = this.doReset.bind(this);
        this.loadData = this.loadData.bind(this);


    }


    componentDidMount() {
        this.setState({
            APISearchData: JSON.parse(JSON.stringify(this.state.search)),
            APIResetData: JSON.parse(JSON.stringify(this.state.search))
        }, () => {
            API.operator.list({ "role": false })
                .then(data => {
                    (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;
                    this.setState({
                        Operators: data.Operators,
                    }, () => {
                        this.loadData();
                    });
                })
                .catch(error => { });
        })
    }
    loadData() {
        API.system.listSystemLog(this.state.APISearchData)
            .then(data => {
                (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;
                this.setState({
                    SystemLogs: data.SystemLogs,
                    paging: data.paging,
                    isLoading: false,
                    isRefreshing: false
                });
            })
            .catch(error => { });
    }
    doSearch() {
        var tmpObj = JSON.parse(JSON.stringify(this.state.search));
        tmpObj.currentPage = 1;
        this.setState({
            APISearchData: tmpObj,
            isRefreshing: true
        },
            () => {
                this.loadData();
            });
    }
    doReset() {
        this.setState({
            search: JSON.parse(JSON.stringify(this.state.APIResetData)),
            APISearchData: JSON.parse(JSON.stringify(this.state.APIResetData)),
            isRefreshing: true
        }, () => {
            this.loadData();
        });
    }
    handleFocus = (event) => event.target.select();
    setCreatedDateRange(start, end) {
        var tmpObj = this.state.search;
        tmpObj.createdFrom = start;
        tmpObj.createdTo = end;
        this.setState({ search: tmpObj });
    }
    setClosedDateRange(start, end) {
        var tmpObj = this.state.search;
        tmpObj.closedFrom = start;
        tmpObj.closedTo = end;
        this.setState({ search: tmpObj });
    }
    toggleSearchForm() {
        const prevState = this.state.toggleSearchForm;
        this.setState({
            toggleSearchForm: !prevState
        });
    }

    render() {

        return (
            this.state.isLoading ?
                <div className="loading"></div>
                :
                <Fragment>
                    <Row className="mb-4 searchdropdown">
                        <Colxx xxs="12">
                            <Card>
                                <CardBody>
                                    <CardTitle>
                                        <div>
                                            <div className={"iconsminds-box-full headingicon"} /> لاگ سیستم
                                            <Button className={"default mb-1"} outline color={"info"} style={{ float: "left", marginRight:"20px",border: "unset", width: "40px", borderRadius: 50, padding: "10px" }} onClick={() => { this.setState({ isRefreshing: true }); this.loadData(); }}>
                                                <div className={" simple-icon-reload tableheadingicon"} />
                                            </Button>
                                        </div>

                                        <div className={'text-muted'} style={{ float: "left", fontSize: "14px" }}>
                                            {" نمایش "}
                                            {<NumberFormat value={this.state.paging.from + 1} displayType={'text'} thousandSeparator={true} renderText={(value, prop) => <span >{value}</span>} />}
                                            {" تا "}
                                            {<NumberFormat value={this.state.paging.to} displayType={'text'} thousandSeparator={true} renderText={(value, prop) => <span >{value}</span>} />}
                                            {" از "}
                                            {<NumberFormat value={this.state.paging.total} displayType={'text'} thousandSeparator={true} renderText={(value, prop) => <span >{value}</span>} />}
                                            {" لاگ سیستم"}
                                        </div>

                                    </CardTitle>

                                    <Fragment>
                                        <div className="border productPanel">
                                            <Button
                                                block
                                                color="link"
                                                className="text-right"
                                                onClick={() => this.toggleSearchForm()}

                                                aria-expanded={this.state.toggleSearchForm}
                                            >
                                                <i className="glyph-icon simple-icon-magnifier" style={{ "marginLeft": "5px", "fontSize": "14px" }}></i>


                                                فرم جستجو
                                                <i className="glyph-icon simple-icon-arrow-down" style={{ "marginRight": "10px", "fontSize": "10px" }}></i>

                                            </Button>
                                            <div className="dropdown-buttons" style={{ float: "left", display: this.state.toggleSearchForm ? "inline-block" : "none" }}>

                                                <Button color="primary" style={{ "float": "left" }} className={"default"} onClick={this.doSearch}>
                                                    جستجو کن
                                                </Button>
                                                <Button color="light" style={{ "float": "left", "marginLeft": "10px" }} className={"default"} onClick={this.doReset}>
                                                    ریست
                                                </Button>
                                            </div>
                                            <Collapse isOpen={this.state.toggleSearchForm}>
                                                <div className="p-4">

                                                    <Row className="mb-4">
                                                        <Colxx xxs="12">

                                                            <Form>
                                                                <br />
                                                                <FormGroup row>
                                                                    <Colxx sm={3}>
                                                                        <FormGroup className={"filter " + (this.state.search.logTitle != "" ? "filter-active" : "")}>
                                                                            <Label for="leadMobile">
                                                                                موضوع ( شامل )
                                                                            </Label>
                                                                            <Input
                                                                                type="text"
                                                                                name="leadMobile"
                                                                                id="leadMobile"
                                                                                onClick={this.handleFocus}
                                                                                value={this.state.search.logTitle}
                                                                                onChange={(e) => { var tmpObj = { ...this.state.search }; tmpObj.logTitle = e.target.value; this.setState({ search: tmpObj }); }}

                                                                            />
                                                                        </FormGroup>
                                                                        <FormGroup className={"filter " + ((this.state.search.operatorID != "ALL") ? "filter-active" : "")}>
                                                                            <Label>
                                                                                اپراتور
                                                                            </Label>
                                                                            <Input type="select"

                                                                                onChange={(e) => { var tmpObj = { ...this.state.search }; tmpObj.operatorID = e.target.value; this.setState({ search: tmpObj }); }}
                                                                                value={this.state.search.operatorID}
                                                                            >
                                                                                <option value="ALL">همه</option>
                                                                                {this.state.Operators.map((operator, index) => (
                                                                                    <option value={operator.OperatorID} key={index}>{operator.Name}</option>
                                                                                ))}

                                                                            </Input>

                                                                        </FormGroup>

                                                                    </Colxx>

                                                                    <Colxx sm={3}>
                                                                        <FormGroup className={"filter " + (this.state.search.logType != "" ? "filter-active" : "")}>
                                                                            <Label for="leadMobile">
                                                                                نوع
                                                                            </Label>
                                                                            <Input
                                                                                type="text"
                                                                                name="leadMobile"
                                                                                id="leadMobile"
                                                                                onClick={this.handleFocus}
                                                                                value={this.state.search.logType}
                                                                                onChange={(e) => { var tmpObj = { ...this.state.search }; tmpObj.logType = e.target.value; this.setState({ search: tmpObj }); }}

                                                                            />
                                                                        </FormGroup>
                                                                        <FormGroup className={"filter " + (this.state.search.logTag != "" ? "filter-active" : "")}>
                                                                            <Label for="leadMobile">
                                                                                برچسب
                                                                            </Label>
                                                                            <Input
                                                                                type="text"
                                                                                name="leadMobile"
                                                                                id="leadMobile"
                                                                                onClick={this.handleFocus}
                                                                                value={this.state.search.logTag}
                                                                                onChange={(e) => { var tmpObj = { ...this.state.search }; tmpObj.logTag = e.target.value; this.setState({ search: tmpObj }); }}

                                                                            />
                                                                        </FormGroup>
                                                                    </Colxx>
                                                                    <Colxx sm={3}>
                                                                        <FormGroup className={"filter " + (this.state.search.logAction != "" ? "filter-active" : "")}>
                                                                            <Label for="leadMobile">
                                                                                فعالیت
                                                                            </Label>
                                                                            <Input
                                                                                type="text"
                                                                                name="leadMobile"
                                                                                id="leadMobile"
                                                                                onClick={this.handleFocus}
                                                                                value={this.state.search.logAction}
                                                                                onChange={(e) => { var tmpObj = { ...this.state.search }; tmpObj.logAction = e.target.value; this.setState({ search: tmpObj }); }}

                                                                            />
                                                                        </FormGroup>

                                                                    </Colxx>
                                                                    <Colxx sm={3}>
                                                                        <FormGroup className={"filter " + ((this.state.search.createdFrom != "" && this.state.search.createdTo != "") ? "filter-active" : "")}>
                                                                            <Button style={{ "float": "left", "padding": "5px", "color": "black", "backgroundColor": "transparent", "border": "unset", "display": ((this.state.search.createdFrom != "" && this.state.search.createdTo != "")) ? "block" : "none" }} onClick={(e) => { var tmpObj = { ...this.state.search }; tmpObj.createdFrom = ""; tmpObj.createdTo = ""; this.setState({ search: tmpObj }); }}>
                                                                                <i className="simple-icon-close"></i>
                                                                            </Button>
                                                                            <RangeDatePicker fromLabel="ثبت شده از تاریخ" toLabel="ثبت شده تا تاریخ" onClickSubmitButton={this.setCreatedDateRange} />
                                                                        </FormGroup>
                                                                    </Colxx>

                                                                </FormGroup>
                                                            </Form>
                                                        </Colxx>
                                                    </Row>

                                                </div>
                                            </Collapse>
                                        </div>
                                        <br />
                                    </Fragment>
                                    {!this.state.isRefreshing ?
                                        <div className="table-responsive">
                                            <table className="table table-hover order-table">
                                                <thead>
                                                    <tr>
                                                        <th>کد لاگ</th>
                                                        <th>زمان ثبت</th>
                                                        <th>نوع</th>
                                                        <th>برچسب </th>
                                                        <th>فعالیت  </th>
                                                        <th>موضوع </th>
                                                        <th>اپراتور</th>
                                                        <th>جزئیات </th>
                                                    </tr>

                                                </thead>

                                                {this.state.SystemLogs.map(row => (
                                                    <TableBodyRows
                                                        key={row.SystemLogID}
                                                        data={row}
                                                    />
                                                ))}

                                                <tfoot>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="table-pagination">
                                                                {this.state.paging.pages.map((page, index) => (
                                                                    <Button key={index} className={classNames({ "mb-2": true, "pagination-item": true, "pagination-number": true, "pagination-current": page.current })} onClick={(e) => { if (page.ellipse) { return; } var tmpObj = { ...this.state.APISearchData }; tmpObj.currentPage = page.page; this.setState({ APISearchData: tmpObj, isRefreshing: true }, () => { this.loadData() }); }}  >
                                                                        {page.page}
                                                                    </Button>
                                                                ))}


                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                        : <div className="loading" style={{ left: "unset", top: "unset", position: "relative", display: "block", marginLeft: "auto", marginRight: "auto" }}></div>}
                                </CardBody>
                            </Card>
                        </Colxx>
                    </Row>
                </Fragment >
        );
    }
}

class TableBodyRows extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            clicked: false
        };
        this.toggle = this.toggle.bind(this);
    }
    toggle() {
        if (this.state.clicked) { return; }
        this.setState({
            modal: !this.state.modal
        });
    }
    render() {
        const {
            data: { SystemLogID, CreatedAt, isNew, Type, Tag, Action, Title, Description, OperatorName },

        } = this.props;
        return (
            <tbody className={classNames({ "newlog": isNew === "1", "logrow": true })}>
                <tr className={"order-spacer"}>

                </tr>
                <tr className={"order-item"}>


                    <td className={"text-muted"}>{SystemLogID}</td>
                    <td className={"text-muted"}>{moment(CreatedAt).locale('fa').format('DD / MMMM / YYYY - HH:mm')}</td>
                    <td className={"text-muted"}>{Type}</td>
                    <td className={"text-muted"}>{Tag}</td>
                    <td className={"text-muted"}>{Action}</td>
                    <td>
                        {Title}
                    </td>
                    <td className={"text-muted"}>{OperatorName}</td>
                    <td className={"text-muted"}>
                        <Button className={" md-2"} outline color={"white"} style={{ border: "1px solid #8fa4ae", color: "#8fa4ae" }} onClick={() => { this.setState({ modal: true }); }}>
                            نمایش
                        </Button>
                        <Modal isOpen={this.state.modal} toggle={this.toggle}>
                            <ModalHeader toggle={this.toggle}>
                                لاگ سیستم #{SystemLogID}
                            </ModalHeader>
                            <ModalBody>


                                <table>

                                    <tbody>
                                        <tr>
                                            <th>موضوع:</th>
                                            <td>{Title}</td>
                                        </tr>
                                        <tr>
                                            <th>تاریخ ایجاد:</th>
                                            <td>{moment(CreatedAt).locale('fa').format('DD / MMMM / YYYY - HH:mm')}</td>
                                        </tr>
                                        <tr>
                                            <th>اپراتور:</th>
                                            <td>{OperatorName}</td>
                                        </tr>
                                        <tr>
                                            <th>اطلاعاات:</th>
                                            <td>{Type}{" :: "}{Tag}{" :: "}{Action}</td>
                                        </tr>
                                        <tr>
                                            <th>توضیحات:</th>
                                            <td dangerouslySetInnerHTML={{ __html: Description }}></td>
                                        </tr>

                                    </tbody>
                                </table>

                            </ModalBody>
                        </Modal>

                    </td>
                </tr>

            </tbody>
        );
    }
}

const mapStateToProps = ({ menu, settings }) => {
    return { logoutUser };
};
export default injectIntl(connect(
    mapStateToProps,
    { logoutUser }
)(archive));
// export default injectIntl(archive);